import { useState, useEffect } from 'react';
import { settingsService } from '../services/firebase/settingsService';

/**
 * Custom hook to fetch and use website settings
 */
export const useSettings = () => {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    const fetchSettings = async () => {
      try {
        const data = await settingsService.getSettings();
        if (isMounted) {
          setSettings(data);
          setLoading(false);
        }
      } catch (err) {
        if (isMounted) {
          setError(err);
          setLoading(false);
        }
      }
    };

    fetchSettings();

    return () => {
      isMounted = false;
    };
  }, []);

  return { settings, loading, error };
};

export default useSettings;
